import { forwardRef, useEffect, useState } from "react";
import { Input } from 'reactstrap';
import InputMask from 'react-input-mask';

const CustomInput = forwardRef((props, ref) => {

    let [value, updateValue] = useState(props.value);
    let className = '';

    const handleChange = element => {
        updateValue(element.target.value);
        props.onChange(element);
    };

    if (props.error) {
        className = "is-invalid";
    }

    useEffect(() => {
        updateValue(props.value)
    }, [props.value]);

    const inputProps = {
        id: `id_${props.name}`,
        onChange: handleChange,
        className,
        value,
        type: props.type,
        name: props.name,
        rows: props.rows,
        readOnly: props.readOnly,
        autoFocus: props.autoFocus ? true : false,
        innerRef: ref
    }
    
    if (props.mask) {
        inputProps.mask = props.mask
        inputProps.maskChar = ''
        inputProps.tag = InputMask
    }else{
        inputProps.maxLength = props.maxLength
    }

    if (props.type === 'month') {
        const isValidYear = (year) => {
            const regex = /^\d{4}$/;
            return regex.test(year);
        };

        const handleMonthChange = (e) => {
            const { value } = e.target;
            const [year, month] = value.split('-');

            if (isValidYear(year) && parseInt(month, 10) >= 1 && parseInt(month, 10) <= 12) {
                handleChange(e);
            }
        };

        inputProps.onChange = handleMonthChange;
    }

    return (
        <div>
            <Input {...inputProps} />

            {props.error && (
                <span
                    className="error invalid-feedback"
                    style={{ display: 'inline' }}>
                    {props.error}
                </span>
            )}
        </div>
    );
})
export default CustomInput;
